import React from 'react';

const ShortKeyCode = ({ shortKey }) => <>{shortKey}••••••••</>;

export default ShortKeyCode;
